module.exports = __webpack_public_path__ + "img/Логотип_телеканала_«Москва_24».92ec9938.png";